// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================= */
/* TABLE */
/* ============================= */
.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border-collapse: separate !important;
  border-spacing: 0 8px !important;
  table-layout: fixed;
}

/* ============================= */
/* HEADER */
/* ============================= */
.rbc-agenda-view table.rbc-agenda-table thead th {
  background: #f8fafc;
  color: #111827;
  font-weight: 600;
  padding: 16px 20px;
  border: none !important;
  text-align: left;
}

/* ============================= */
/* ROWS */
/* ============================= */
.rbc-agenda-view table.rbc-agenda-table tbody tr {
  overflow: hidden;
  border-radius: 14px;
}

/* CELLS */
.rbc-agenda-view table.rbc-agenda-table tbody td {
  padding: 18px 20px !important;
  border: none !important;
  vertical-align: middle !important;
  font-weight: 500;
  color: #ffffff !important;
}

/* LEFT EDGE */
.rbc-agenda-view table.rbc-agenda-table tbody tr td:first-child {
  border-top-left-radius: 14px;
  border-bottom-left-radius: 14px;
}

/* RIGHT EDGE */
.rbc-agenda-view table.rbc-agenda-table tbody tr td:last-child {
  border-top-right-radius: 14px;
  border-bottom-right-radius: 14px;
}

/* ============================= */
/* COLUMN WIDTHS */
/* ============================= */
.rbc-agenda-view table.rbc-agenda-table th:nth-child(1),
.rbc-agenda-view table.rbc-agenda-table td:nth-child(1) {
  width: 220px;
}

.rbc-agenda-view table.rbc-agenda-table th:nth-child(2),
.rbc-agenda-view table.rbc-agenda-table td:nth-child(2) {
  width: 280px;
}

.rbc-agenda-view table.rbc-agenda-table th:nth-child(3),
.rbc-agenda-view table.rbc-agenda-table td:nth-child(3) {
  width: auto;
}

/* ============================= */
/* REMOVE DEFAULT RBC EVENT STYLE */
/* ============================= */
.rbc-agenda-view .rbc-event,
.rbc-agenda-view .rbc-event-content,
.rbc-agenda-view .rbc-event-label {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: inherit !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline !important;
}

/* ============================= */
/* STATUS COLORS */
/* ============================= */
.rbc-agenda-view tr:has(.agenda-status-completed) td {
  background: #2E7D32 !important;
}

.rbc-agenda-view tr:has(.agenda-status-scheduled) td {
  background: #8E5BB7 !important;
}

.rbc-agenda-view tr:has(.agenda-status-cancelled) td,
.rbc-agenda-view tr:has(.agenda-status-canceled) td {
  background: #F5222D !important;
}

.rbc-agenda-view tr:has(.agenda-status-checkin) td,
.rbc-agenda-view tr:has(.agenda-status-check-in) td {
  background: #E6A23C !important;
}

.rbc-agenda-view tr:has(.agenda-status-past) td {
  background: #A9A9A9 !important;
}

.rbc-agenda-view tr:has(.agenda-status-rescheduled) td {
  background: #1976D2 !important;
}

/* ============================= */
/* HOVER */
/* ============================= */
.rbc-agenda-view table.rbc-agenda-table tbody tr:hover td {
  filter: brightness(1.03);
  transition: 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/pages/Appointments/appointment.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA,UAAA;AACA,kCAAA;AAEA;EACE,WAAA;EACA,oCAAA;EACA,gCAAA;EACA,mBAAA;AAAF;;AAGA,kCAAA;AACA,WAAA;AACA,kCAAA;AAEA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AADF;;AAIA,kCAAA;AACA,SAAA;AACA,kCAAA;AAEA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA,UAAA;AACA;EACE,6BAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,yBAAA;AAFF;;AAKA,cAAA;AACA;EACE,4BAAA;EACA,+BAAA;AAFF;;AAKA,eAAA;AACA;EACE,6BAAA;EACA,gCAAA;AAFF;;AAKA,kCAAA;AACA,kBAAA;AACA,kCAAA;AAEA;;EAEE,YAAA;AAHF;;AAMA;;EAEE,YAAA;AAHF;;AAMA;;EAEE,WAAA;AAHF;;AAMA,kCAAA;AACA,mCAAA;AACA,kCAAA;AAEA;;;EAGE,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,0BAAA;AAJF;;AAOA,kCAAA;AACA,kBAAA;AACA,kCAAA;AAEA;EACE,8BAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAQA;;EAEE,8BAAA;AALF;;AAQA;;EAEE,8BAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAQA,kCAAA;AACA,UAAA;AACA,kCAAA;AAEA;EACE,wBAAA;EACA,qBAAA;AANF","sourcesContent":["/* ============================= */\n/* TABLE */\n/* ============================= */\n\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border-collapse: separate !important;\n  border-spacing: 0 8px !important;\n  table-layout: fixed;\n}\n\n/* ============================= */\n/* HEADER */\n/* ============================= */\n\n.rbc-agenda-view table.rbc-agenda-table thead th {\n  background: #f8fafc;\n  color: #111827;\n  font-weight: 600;\n  padding: 16px 20px;\n  border: none !important;\n  text-align: left;\n}\n\n/* ============================= */\n/* ROWS */\n/* ============================= */\n\n.rbc-agenda-view table.rbc-agenda-table tbody tr {\n  overflow: hidden;\n  border-radius: 14px;\n}\n\n/* CELLS */\n.rbc-agenda-view table.rbc-agenda-table tbody td {\n  padding: 18px 20px !important;\n  border: none !important;\n  vertical-align: middle !important;\n  font-weight: 500;\n  color: #ffffff !important;\n}\n\n/* LEFT EDGE */\n.rbc-agenda-view table.rbc-agenda-table tbody tr td:first-child {\n  border-top-left-radius: 14px;\n  border-bottom-left-radius: 14px;\n}\n\n/* RIGHT EDGE */\n.rbc-agenda-view table.rbc-agenda-table tbody tr td:last-child {\n  border-top-right-radius: 14px;\n  border-bottom-right-radius: 14px;\n}\n\n/* ============================= */\n/* COLUMN WIDTHS */\n/* ============================= */\n\n.rbc-agenda-view table.rbc-agenda-table th:nth-child(1),\n.rbc-agenda-view table.rbc-agenda-table td:nth-child(1) {\n  width: 220px;\n}\n\n.rbc-agenda-view table.rbc-agenda-table th:nth-child(2),\n.rbc-agenda-view table.rbc-agenda-table td:nth-child(2) {\n  width: 280px;\n}\n\n.rbc-agenda-view table.rbc-agenda-table th:nth-child(3),\n.rbc-agenda-view table.rbc-agenda-table td:nth-child(3) {\n  width: auto;\n}\n\n/* ============================= */\n/* REMOVE DEFAULT RBC EVENT STYLE */\n/* ============================= */\n\n.rbc-agenda-view .rbc-event,\n.rbc-agenda-view .rbc-event-content,\n.rbc-agenda-view .rbc-event-label {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  color: inherit !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  display: inline !important;\n}\n\n/* ============================= */\n/* STATUS COLORS */\n/* ============================= */\n\n.rbc-agenda-view tr:has(.agenda-status-completed) td {\n  background: #2E7D32 !important;\n}\n\n.rbc-agenda-view tr:has(.agenda-status-scheduled) td {\n  background: #8E5BB7 !important;\n}\n\n.rbc-agenda-view tr:has(.agenda-status-cancelled) td,\n.rbc-agenda-view tr:has(.agenda-status-canceled) td {\n  background: #F5222D !important;\n}\n\n.rbc-agenda-view tr:has(.agenda-status-checkin) td,\n.rbc-agenda-view tr:has(.agenda-status-check-in) td {\n  background: #E6A23C !important;\n}\n\n.rbc-agenda-view tr:has(.agenda-status-past) td {\n  background: #A9A9A9 !important;\n}\n\n.rbc-agenda-view tr:has(.agenda-status-rescheduled) td {\n  background: #1976D2 !important;\n}\n\n/* ============================= */\n/* HOVER */\n/* ============================= */\n\n.rbc-agenda-view table.rbc-agenda-table tbody tr:hover td {\n  filter: brightness(1.03);\n  transition: 0.2s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
